/* import __COLOCATED_TEMPLATE__ from './fin-participated-filter.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isPresent } from '@ember/utils';

export default class FinParticipatedFilter extends Component {
  @service store;
  @service intercomEventService;
  @service intl;

  @tracked label = this.currentLabel;
  @tracked selected = this.startingSelectedValue;

  get valueLabelMapping() {
    return {
      true: this.intl.t(
        'components.reporting.custom.chart-builder.filter-bar.fin-participated.is-true',
      ),
      false: this.intl.t(
        'components.reporting.custom.chart-builder.filter-bar.fin-participated.is-false',
      ),
    };
  }

  get startingSelectedValue() {
    let passedValue = this.args.selected?.values?.[0];

    if (isPresent(passedValue)) {
      return passedValue;
    }

    return true;
  }

  get currentLabel() {
    return this.valueLabelMapping[String(this.selected)] || '';
  }

  get values() {
    return [this.selected];
  }

  @action
  onClose() {
    this.args.setSelected(this.values);
    this.label = this.currentLabel;
  }

  @action
  removeFilter() {
    this.selected = null;
    this.args.removeFilter();
  }
}
